import { Routes } from '@angular/router';
import { ClientsFormComponent } from 'src/app/pages/clients/clients-form/clients-form.component';
import { ClientsListComponent } from 'src/app/pages/clients/clients-list/clients-list.component';
import { EmployeeFormComponent } from 'src/app/pages/employee/employee-form/employee-form.component';
import { EmployeeListComponent } from 'src/app/pages/employee/employee-list/employee-list.component';
import { HomeComponent } from 'src/app/pages/home/home.component';

export const masterPanelRoutes: Routes = [
  { path: 'home', component: HomeComponent},
  { path: 'clients', component: ClientsListComponent},
  { path: 'clients/form', component: ClientsFormComponent },
  { path: 'clients/form/:id', component: ClientsFormComponent },
  { path: 'employees', component: EmployeeListComponent},
  { path: 'employees/form', component: EmployeeFormComponent },
  { path: 'employees/form/:id', component: EmployeeFormComponent },
  { path: 'users', loadChildren: () => import('src/app/pages/users/users.routes').then(e => e.USERS_ROUTES)},
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: '**', redirectTo: 'home' },
];
